<template>
  <vc-tutorial>
    <div class="vc-tutorial__content">
      <vc-tutorial-carousel class="vc-carousel">
        <li>
          <div class="vc-tutorial__content-header">
            <h2>
              Por que realizar uma
              <span>conciliação bancária</span> regularmente?
            </h2>
          </div>
          <div class="vc-tutorial__content-info">
            <div class="vc-info-box">
              <h2>Compare registros</h2>
              <p>
                Compare os registros financeiros <b>internos</b> com os
                <b>extratos bancários</b>
              </p>
              <img alt="Imagem compare registro" :src="compareRegistro" />
              <p>
                Identifique <b>discrepâncias</b> ou <b>erros</b> no lançamentos
              </p>
            </div>

            <div class="vc-info-box">
              <h2>Gestão financeira eficiente</h2>
              <p>
                Ajuda a manter um <b>controle</b> mais preciso do seu
                <b>fluxo de caixa</b> e registros
                <b>contabilizados corretamente</b>
              </p>
              <img
                alt="Imagem saldo em conta atualizado"
                :src="gestaoFinanceiraEficiente"
              />
              <p>
                A conciliação bancária é <b>essencial</b> para uma boa gestão
              </p>
            </div>
          </div>
        </li>
        <li>
          <div class="vc-tutorial__content-header">
            <h2>
              Aumente a <span>precisão</span> das finanças realizando a
              <span>conciliação bancária</span>
            </h2>
            <small>
              <b>Após filtrar</b> uma conta, <b>selecione a data desejada</b> e
              clique <b>duas vezes</b> no dia específico
            </small>
          </div>
          <div class="vc-tutorial__content-info">
            <img
              alt="Imagem conciliação bancária"
              :src="realizandoConciliacaoBancaria"
            />
          </div>
        </li>
        <li>
          <div class="vc-tutorial__content-header">
            <h2>
              <span>Mova</span> os extratos bancários para o
              <span>Movimento do Sistema</span>
            </h2>
            <small>
              <b>Selecione</b> os valores <b>pendentes</b> que deseja conciliar
              e <b>arraste-os</b> para os movimentos do sistema
            </small>
          </div>
          <div class="vc-tutorial__content-info">
            <img alt="Imagem Extrato bancário" :src="extratoBancario" />
          </div>
        </li>
      </vc-tutorial-carousel>
    </div>
  </vc-tutorial>
</template>

<script setup lang="ts">
import compareRegistro from "./Images/ContasMovimento/compareRegistro.svg";
import gestaoFinanceiraEficiente from "./Images/ContasMovimento/gestaoFinanceiraEficiente.svg";
import realizandoConciliacaoBancaria from "./Images/ContasMovimento/realizandoConciliacaoBancaria.gif";
import extratoBancario from "./Images/ContasMovimento/extratoBancario.gif";
</script>
<style lang="scss">
@import url("./style.scss");
</style>
